import React, { useMemo } from "react";
import "../styles/PaginationControls.css";
import { useI18n } from "../providers/I18nProvider";

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const PaginationControls = ({
  totalItems,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 30],
}) => {
  const { t } = useI18n();

  const totalPages = useMemo(() => {
    const n = Math.ceil((Number(totalItems) || 0) / (Number(pageSize) || 1));
    return n > 0 ? n : 1;
  }, [totalItems, pageSize]);

  const safePage = clamp(Number(page) || 1, 1, totalPages);
  const from = totalItems ? (safePage - 1) * pageSize + 1 : 0;
  const to = totalItems ? Math.min(safePage * pageSize, totalItems) : 0;

  return (
    <div className="pagination-controls">
      <div className="pagination-left">
        <span className="pagination-label">{t("common.pagination.rowsPerPage")}:</span>
        <select
          className="pagination-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <span className="pagination-range mono">
          {from}-{to} / {totalItems || 0}
        </span>
      </div>

      <div className="pagination-right">
        <button
          className="pagination-btn"
          type="button"
          onClick={() => onPageChange(1)}
          disabled={safePage <= 1}
          aria-label={t("common.pagination.first")}
        >
          {"<<"}
        </button>
        <button
          className="pagination-btn"
          type="button"
          onClick={() => onPageChange(safePage - 1)}
          disabled={safePage <= 1}
        >
          {t("common.pagination.prev")}
        </button>
        <span className="pagination-page mono">
          {t("common.pagination.page")} {safePage} / {totalPages}
        </span>
        <button
          className="pagination-btn"
          type="button"
          onClick={() => onPageChange(safePage + 1)}
          disabled={safePage >= totalPages}
        >
          {t("common.pagination.next")}
        </button>
        <button
          className="pagination-btn"
          type="button"
          onClick={() => onPageChange(totalPages)}
          disabled={safePage >= totalPages}
          aria-label={t("common.pagination.last")}
        >
          {">>"}
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;

